import React from 'react';
import style from './DashboardUnavailableCourierList.module.scss';
import UnavailableCourierListImage from '@src/assets/unavailablecourierlist.png';
import PIEText from '@src/shared/components/PIEText';
import { useTranslation } from 'react-i18next';
import { globalStyles } from 'snacks-design-system';
const {
  xdsFontSize20,
  xdsFontSize16,
  xdsFontWeightExtrabold,
  xdsFontWeightRegular,
} = globalStyles;
const DashboardUnavailableCourierList = () => {
  const { t } = useTranslation();
  return (
    <div className={style.DashboardUnavailableCourierList}>
      <img src={UnavailableCourierListImage} />
      <div className={style.title}>
        <PIEText
          fontWeight={xdsFontWeightExtrabold}
          text={t('dashboard.unavailable_COURIERS_TITLE')}
          size={xdsFontSize20}
        />
      </div>
      <div className={style.description}>
        <PIEText
          text={t('dashboard.unavailable_COURIERS_DESCRIPTION')}
          fontWeight={xdsFontWeightRegular}
          size={xdsFontSize16}
        />
      </div>
    </div>
  );
};

export default DashboardUnavailableCourierList;
